// extracted by extract-css-chunks-webpack-plugin
module.exports = {"icon":"_3tSku_","panelContainer":"_3JTOEs","title":"_29oby1","generateOutlineAttributes":"_29sizz","body":"NstV5K"};